import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const labratorDetailApi = createApi({
    reducerPath: "core/detail/labrator",
    baseQuery: axiosBaseQuery,
    tagTypes: ["labratorDetailList"],
    endpoints: (builder) =>({
        labratorDetailFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['labratorDetailList'],
            query: (query = '') => ({
                url: "/core/detail/labrator" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        labratorDetailCreate: builder.mutation({
            invalidatesTags: ['labratorDetailList'],
            query: (data)=>({url: "/core/detail/labrator/", method: "POST", data})
        }),
        labratorDetailUpdate: builder.mutation({
            invalidatesTags: ['labratorDetailList'],
            query: (data)=>({url: "/core/detail/labrator/"+data.lab_id, method: "PUT", data})
        }),
        // console.log(data);
        
        labratorDetailDelete: builder.mutation({
            invalidatesTags: ['labratorDetailList'],
            query: (id)=>({url: "/core/detail/labrator/"+id, method: "DELETE"})
        }),
    })
})

export const { useLabratorDetailFindAllQuery, useLabratorDetailCreateMutation, useLabratorDetailUpdateMutation, useLabratorDetailDeleteMutation } = labratorDetailApi;
export {labratorDetailApi};
